import React, { useEffect, useState } from 'react';
import { FileListData } from '@typings/ResidentTypes';
import { truncateFileName } from '@utils/commons';
import Pagination from '@components/pagination';

interface UploadedFileTableProps {
  headerTitle?: string;
  fileList: FileListData[];
  setFileList: (files: FileListData[]) => void;
}

const UploadedFileTable: React.FC<UploadedFileTableProps> = ({
  headerTitle,
  fileList,
  setFileList,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentItems, setCurrentItems] = useState<FileListData[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 10;

  useEffect(() => {
    setCurrentItems(
      fileList?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      ) || []
    );

    const total = Math.ceil(fileList.length / itemsPerPage);
    setTotalPages(total);

    if (currentPage > total && total > 0) {
      setCurrentPage(total);
    }
  }, [currentPage, fileList]);

  const handleDeleteFile = (key: string) => {
    const newFileList: FileListData[] = fileList?.filter(
      file => file.id !== key
    );
    setFileList(newFileList);
  };

  return (
    <div>
      <table className="govuk-table">
        <thead className="govuk-table__head">
          <tr className="govuk-table__row">
            <th
              scope="col"
              className="govuk-table__header govuk-!-width-three-quarters"
            >
              {headerTitle || 'File Name'}
            </th>
            <th
              scope="col"
              className="govuk-table__header govuk-!-width-one-quarter"
            >
              {' '}
            </th>
          </tr>
        </thead>
        <tbody className="govuk-table__body">
          {currentItems.map((file: FileListData) => (
            <tr className="govuk-table__row" key={file.id}>
              <td className="govuk-table__cell column-1" title={file.name}>
                {truncateFileName(file.name, 50)}
              </td>
              <td className="govuk-table__cell">
                <div className="govuk-button-group">
                  <button
                    type="button"
                    className="govuk-button"
                    data-module="govuk-button"
                    onClick={() => window.open(file.data, '_blank')}
                  >
                    Download
                  </button>
                  <button
                    type="button"
                    className="govuk-button govuk-button--warning"
                    data-module="govuk-button"
                    onClick={() => handleDeleteFile(file.id)}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
    </div>
  );
};

UploadedFileTable.defaultProps = {
  headerTitle: 'File Name',
};

export default UploadedFileTable;
